<template>
  <DialogPrime :visible="visible" :style="{width: '450px'}" header="Detalles del Usuario" :modal="true" class="p-fluid">
    <div class="p-field">
      <label for="nombreUsuario">Nombre de Usuario</label>
      <InputText id="nombreUsuario" v-model.trim="localUsuario.NombreUsuario" required autofocus />
    </div>
    <div class="p-field">
      <label for="nombre">Nombre</label>
      <InputText id="nombre" v-model.trim="localUsuario.Nombre" required />
    </div>
    <div class="p-field">
      <label for="apellidoPaterno">Apellido Paterno</label>
      <InputText id="apellidoPaterno" v-model.trim="localUsuario.ApellidoPaterno" required />
    </div>
    <div class="p-field">
      <label for="apellidoMaterno">Apellido Materno</label>
      <InputText id="apellidoMaterno" v-model.trim="localUsuario.ApellidoMaterno" required />
    </div>
    <div class="p-field">
      <label for="rut">RUT</label>
      <InputText id="rut" v-model.trim="localUsuario.IdentificadorRut" required />
    </div>
    <div class="p-field">
      <label for="email">Email</label>
      <InputText id="email" v-model.trim="localUsuario.Email" required />
    </div>
    <div class="p-field">
      <label for="celular">Celular</label>
      <InputText id="celular" v-model.trim="localUsuario.Celular" />
    </div>
    <div class="p-field">
      <label for="perfil">Perfil</label>
      <DropDown id="perfil" v-model="localUsuario.Perfil" :options="perfiles" optionLabel="Glosa" placeholder="Seleccione un perfil" />
    </div>
    <template #footer>
      <ButtonPrime label="Cancelar" icon="pi pi-times" class="p-button-text" @click="cerrarDialog" />
      <ButtonPrime label="Guardar" icon="pi pi-check" class="p-button-text" @click="guardarUsuario" />
    </template>
  </DialogPrime>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  props: {
    visible: Boolean,
    usuario: Object,
    perfiles: Array,
    cerrarDialog: Function,
    guardarUsuario: Function,
  },
  setup(props) {
    const localUsuario = ref({ ...props.usuario });

    // Observa cambios en el prop usuario y actualiza localUsuario
    watch(() => props.usuario, (newValue) => {
      localUsuario.value = { ...newValue };
    });

    return {
      localUsuario,
    };
  }
}
</script>

<style scoped>
/* Estilos específicos para UserDialog */
</style>